import { ConstructClassWithPrivateMembers } from '../../misc/helpers/ClassWithPrivateMembers';
import { OBSERVER_PRIVATE } from './privates';
import { IsObject } from '../../helpers';
export function ConstructObserver(instance, onEmit) {
    ConstructClassWithPrivateMembers(instance, OBSERVER_PRIVATE);
    const privates = instance[OBSERVER_PRIVATE];
    privates.activated = false;
    privates.observables = [];
    if (typeof onEmit === 'function') {
        privates.onEmit = onEmit.bind(instance);
    }
    else {
        throw new TypeError(`Expected function as first argument of Observer.`);
    }
}
export function IsObserver(value) {
    return IsObject(value)
        && value.hasOwnProperty(OBSERVER_PRIVATE);
}
//# sourceMappingURL=constructor.js.map